// extracted by mini-css-extract-plugin
export default {"msgM":"a566cd9d14"};